import { PageHeader, Row, Tag } from 'antd';
import MapCard from 'app/containers/Map/parts/MapCard/MapCard';
import { MapModeEnum } from 'app/containers/Map/slice/types';
import React, { FC } from 'react';
import TaskTabs from '../../parts/TaskTabs/TaskTabs';
import { detailsViewTypeEnum } from '../../slice/types';
import * as S from './TaskDetails.styles';
import { SelectedFieldsSummary } from '../../parts/SelectedFieldsSummary/SelectedFieldsSummary';
import TaskResourcesCard from '../../parts/TaskResourcesCard/TaskResourcesCard';
import { toFixedIfFloat } from 'utils/helpers';
import { TaskCompaniesCard } from '../../parts/TaskCompaniesCard/TaskCompaniesCard';
import TaskCulturesCard from '../../parts/TaskCulturesCard/TaskCulturesCard';
import TaskBasicInfoCard from '../../parts/TaskBasicInfoCard/TaskBasicInfoCard';
import TaskDetailsHeaderButtons from './parts/TaskDetailsHeaderButtons';
import { getTaskStatusText } from '../../../../../utils/helpers';
import DeclinedTaskComment from '../../parts/DeclinedTaskComment/DeclinedTaskComment';
import { useTaskDetails } from './hooks/useTaskDetails';
import RoutesWithotTaskFiltersCard from '../TaskListPage/parts/RoutesWithotTaskFiltersCard/RoutesWithotTaskFiltersCard';
import TaskRoutesListCard from 'app/components/RouteListCards/TaskRoutesListCard/TaskRoutesListCard';

interface IProps {}

const TaskDetails: FC<IProps> = () => {
  const {
    theme,
    mobileOrTablet,
    taskId,
    task,
    onBack,
    onClickMenu,
    selectedKey,
    areaByCompanies,
    areaByCultures,
    isTaskRoutes,
  } = useTaskDetails();

  if (!taskId || !task) {
    return null;
  }

  const responsivePadding = mobileOrTablet ? 6 : 12;

  return (
    <>
      <PageHeader
        onBack={onBack}
        className="page-header"
        title={task.name}
        subTitle={`${toFixedIfFloat(task.totalArea || 0)} ha`}
        tags={
          task.status ? (
            <Tag color={theme.taskStatusColor[task.status]}>
              {getTaskStatusText(task.status)}
            </Tag>
          ) : undefined
        }
        extra={
          <TaskDetailsHeaderButtons taskId={taskId} status={task.status} />
        }
      />
      <Row
        wrap={mobileOrTablet}
        gutter={responsivePadding}
        style={{
          paddingLeft: responsivePadding,
          paddingTop: responsivePadding,
          width: '100%',
        }}
      >
        <S.LeftCol>
          <TaskTabs
            isRoutes={isTaskRoutes}
            onClickMenu={onClickMenu}
            selectedKey={selectedKey}
          />
          {selectedKey === detailsViewTypeEnum.routes ? (
            <div style={{ marginTop: 12 }}>
              <RoutesWithotTaskFiltersCard />
              <TaskRoutesListCard taskId={taskId} />
            </div>
          ) : (
            <>
              <TaskBasicInfoCard
                categoryName={task.category.name}
                endDate={task.endDate}
                startDate={task.startDate}
                notes={task.note ?? undefined}
              />

              <DeclinedTaskComment task={task} />

              <SelectedFieldsSummary fieldTasks={task.fieldTasks} />
              <TaskCompaniesCard data={areaByCompanies} />
              <TaskCulturesCard areaByCultures={areaByCultures} />
            </>
          )}
        </S.LeftCol>

        <S.MapAndResourcesCol>
          {selectedKey === detailsViewTypeEnum.map ||
          selectedKey === detailsViewTypeEnum.routes ? (
            <MapCard
              mode={
                selectedKey === detailsViewTypeEnum.routes
                  ? MapModeEnum.taskRoutes
                  : MapModeEnum.taskFields
              }
              showLayerMenu={selectedKey !== detailsViewTypeEnum.routes}
              showSelectFieldsByCulture={
                selectedKey !== detailsViewTypeEnum.routes
              }
            />
          ) : (
            <TaskResourcesCard />
          )}
        </S.MapAndResourcesCol>
      </Row>
    </>
  );
};

export default TaskDetails;
